module.exports = __webpack_public_path__ + "static/media/icon_h.05d25bd9.svg";